import { format } from "date-fns";
import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  useAddCustomerMutation,
  useCustomerCountQuery,
  useCustomerPagenationQuery,
  useCustomersExportQuery,
  useCustomersQuery,
  useDeleteCustomerMutation,
} from "../../services/customerApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import CreateCustomerForm from "../Common/Form/CreateCustomerForm";
import Header from "../Common/Header/Header";
import CustomerExportModal from "../Common/Modal/CustomerExportModal";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { apiUniqueErrHandle } from "../Utility/Utility";
import "./Customer.css";

const Customer = () => {
  const auth = signInUser();
  const { aamarId, storeSettings } = auth;
  let navigate = useNavigate();
  const lang = useSelector((state) => state.languageReducer);

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const id = uuidv4();
  const [Addcustomer] = useAddCustomerMutation();
  const [deleteCustomer] = useDeleteCustomerMutation();
  const [pageCount, setPageCount] = useState(0);
  const [pageNo, setPageNo] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [q, setQ] = useState("");
  const [group, setGroup] = useState("");
  const [warehouse, setWarehouse] = useState("allWh");
  const CustomersView = useCustomersQuery();

  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);

  // console.log("user", auth);

  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useCustomerPagenationQuery({
      page,
      size,
      warehouse,
      aamarId,
      q,
    });
  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);
  // console.log(data);
  // const [Datacustomer] = useCustomerQuery(`${_id}`);
  const [onShowCustomer, setOnShowCustomer] = useState(false);
  const handleCloseCustomer = () => setOnShowCustomer(false);
  const [onShowGroup, setOnShowGroup] = useState(false);
  const handleCloseGroup = () => setOnShowGroup(false);

  const { data: customer, isSuccess: isSuccessCustomer } =
    useCustomersExportQuery({ warehouse, aamarId });

  const { register, handleSubmit, reset, setValue } = useForm();
  // console.log(customer)
  let i = 1;
  const handleSelectGroup = (e) => {
    // console.log("Selected Option:", e);

    // Safely handle the case when e is null or no-Group
    if (e && e.value && e.value !== "no-Group") {
      setGroup(e.value); // Update group with the selected value
      setValue("group", e.value, {
        shouldValidate: true,
        shouldDirty: true,
      });
    } else {
      setGroup(null); // Reset group if no option is selected
      setValue("group", null, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };
  const onSubmit = async (customer) => {
    // console.log("customer Create", customer);
    let newCustomer = {};

    newCustomer = {
      name: customer?.name,
      password: customer?.password,
      phone: customer?.phone,
      email: customer?.email,
      username: customer?.username,
      membership: customer?.membership,
      address: [
        {
          type: "Home",
          id: id ||"",
          holdingNo: customer?.holdingNo,
          sector: customer?.sector,
          street: customer?.street,
          town: customer?.town,
          city: customer?.city,
          division: customer?.division,
          country: customer?.country,
          zipCode: customer?.zipCode,
        },
      ],
      point: customer?.point ? customer?.point : 0,
      type: customer?.type,
      group:
        customer?.group && customer?.group !== "no-Group"
          ? customer?.group
          : null,
      warehouse: auth?.warehouse,
      aamarId: auth?.aamarId,
      status: customer?.status,
    };
    // console.log("newCustomer", newCustomer);
    setLoader(true);

    try {
      // console.log(data);
      const response = await Addcustomer(newCustomer);
      if (response) {
        // console.log(response);
        if (response?.error) {
          apiUniqueErrHandle(response);
        } else {
          reset({
            name: "",
            username: "",
            password: "",
            membership: "",
            address: "",
            holdingNo: "",
            sector: "",
            street: "",
            town: "",
            city: "",
            division: "",
            country: "",
            zipCode: "",
            phone: "",
            email: "",
            type: "",
            group: "",
            warehouse: auth?.warehouse,
            aamarId: auth?.aamarId,
            status: "active",
          });
          notify("Customer Create Successful!", "success");

          // console.log(response?.data?.message);
          return navigate("/customer");
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoader(true);
    try {
      const result = await Swal.fire({
        title: "Are you Sure?",
        text: "Delete this Customer?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const res = await deleteCustomer(id);
        if (res) {
          // TODO::
          // add error hendaler for delete error
          // console.log(res);
        } else {
          // console.log("Delete Operation Canceled by Customer!");
          return;
        }
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoader(false);
    }
  };

  const handleReset = () => {
    reset({
      name: "",
      phone: "",
      address: "",
    });
  };

  // get totel product count
  const pageCountQuery = useCustomerCountQuery({ aamarId });
  useEffect(() => {
    const { data } = pageCountQuery;
    setPageCount(data);
  }, [pageCountQuery]);

  const handleDataLimit = (e) => {
    setSize(parseInt(e.target.value));
    setPageNo(getPageNumber);
  };

  // console.log(pageCount, size);
  const getPageNumber = () => {
    const cont = Math.ceil(parseInt(pageCount) / parseInt(size));
  };

  const handleSearch = (e) => {
    setQ(e.target.value);
    refetch();
  };

  const handlePageClick = (data) => {
    setPage(parseInt(data.selected));
    setPageNo(getPageNumber);
  };
  const handleCustomerExport = () => {
    setOnShowCustomer(true);
    // console.log(onShowCustomer);
    // console.log(customer);
  };
  const handleGroup = () => {
    setOnShowGroup(true);
    // console.log(onShowGroup);
    // console.log("");
  };
  useEffect(() => {
    refetch();
  }, [warehouse, page, size]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["Customer Details"],

    [], // Empty row for spacing
  ];
  return (
    <div>
      <div className="container-fluid">
        {/* Loading Modal */}
        <LoadingModal
          title="Please Wait"
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>

        <div className="row">
          <div className="col-md-2">
            {/* Sidebar */}
            <SideBar />
          </div>
          <div className="col-md-10">
            {/* Header */}
            <Header title={lang?.customer} />

            <div className="row">
              {/* Filters Section */}
              <div className="col-md-4">
                <form action="javascript:void(0);">
                  <div className="input-group mt-2 mb-2">
                    {/* Data Limit Dropdown */}
                    <select
                      className="form-select rounded"
                      onChange={(e) => handleDataLimit(e)}
                      style={{
                        borderTopLeftRadius: "0.5rem",
                        borderBottomLeftRadius: "0.5rem",
                      }}
                    >
                      <option value="100">100</option>
                      <option value="150">150</option>
                      <option value="200">200</option>
                      <option value="250">250</option>
                    </select>

                    {/* Search Input */}
                    <input
                      className="form-control rounded ms-2"
                      type="text"
                      onKeyUp={(e) => handleSearch(e)}
                      placeholder="Search..."
                      style={{
                        borderTopRightRadius: "0.5rem",
                        borderBottomRightRadius: "0.5rem",
                      }}
                    />
                  </div>
                </form>

                {/* Warehouse Selector */}
                {auth?.type === "admin" && (
                  <div
                    className="mt-2 mt-md-0 mb-2 mb-md-0 "
                    style={{
                      width:
                        window.innerWidth >= 1024
                          ? 280
                          : window.innerWidth >= 768
                          ? 280
                          : "100%", // Adjust width based on screen size
                    }}
                  >
                    <WareHouseDW
                      id="warehouse"
                      name="warehouse"
                      handleOnChange={handleOnchangeWareHouseFrom}
                      className="form-control "
                    />
                  </div>
                )}
              </div>

              {/* Pagination Section */}
              <div className="col-md-3">
                <nav
                  aria-label="Page navigation example"
                  className="mt-2"
                  style={{ padding: "0.5rem" }}
                >
                  <ReactPaginate
                    previousLabel={"<<"}
                    nextLabel={">>"}
                    breakLabel={"..."}
                    pageCount={Math.ceil(parseInt(pageCount) / parseInt(size))}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={6}
                    onPageChange={handlePageClick}
                    containerClassName="pagination pt-0 pb-2 justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                  />
                </nav>
              </div>
              <div className="col-md-5 mt-md-2 mb-2">
                <div className="float-end">
                  <Button
                    className="btn btn-dark float-end "
                    onClick={() => handleCustomerExport()}
                    // style={{ borderRadius: "0.5rem" }}
                  >
                    <Icons.DownloadOutline size={20} /> {lang?.exportDetails || "Export Details"}
                  </Button>

                  <Link
                    className="btn btn-dark mb-2 float-end me-2 "
                    to="/customer/importCustomer"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline>{" "}
                    {lang?.importCustomer || "Import Customer"}
                  </Link>
                </div>
              </div>

              {/* Customer Table */}
              <div className="col-md-7 mt-3 mt-md-0 mb-md-5">
                <div className="table-responsive-sm">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Customer</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Membership</th>
                        <th scope="col">Points</th>
                        <th scope="col" className="text-end">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length > 0 ? (
                        data?.map((Customer) => (
                          <tr key={Customer._id}>
                            <th scope="row">{i++}</th>
                            <td>{Customer.name}</td>
                            <td>
                              {Customer.phone ? Customer.phone : "No Phone"}
                            </td>
                            <td>{Customer.membership}</td>
                            <td>{Customer.point}</td>
                            <td className="text-end">
                              <Link to={`/customer/ledger/${Customer._id}`}>
                                <Icons.DocumentTextOutline
                                  className="icon-edit"
                                  size={20}
                                />
                              </Link>
                              <Link to={`/customer/update/${Customer._id}`}>
                                <Icons.PencilAltOutline
                                  className="icon-edit"
                                  size={20}
                                />
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6}>No Customer Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Customer Creation Form */}
              <div className="col-md-5 mt-3 mt-md-0 ">
                <div className="card mt-2">
                  <div className="card-header">
                    <h5 className="card-title">
                      <Icons.UserAddOutline /> {lang?.createCustomer}
                    </h5>
                  </div>
                  <div className="card-body">
                    <CreateCustomerForm
                      onSubmit={onSubmit}
                      useForm={useForm}
                      handleSelectGroup={handleSelectGroup}
                      group={group}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <Toaster position="bottom-right" />
      <CustomerExportModal
        preheader={preHeader}
        onShow={onShowCustomer}
        handleClose={handleCloseCustomer}
        exportCustomer={customer}
      />
      {/* <GroupModal
      onShow={onShowGroup}
      handleClose={handleCloseGroup}
    /> */}
    </div>
  );
};

export default Customer;
